module.exports = __webpack_public_path__ + "img/checkmark-serif.def20387.svg";